module.exports = __webpack_public_path__ + "img/fecha_de_publicacion.35b0bda4.svg";